export default {
  "content": "<g clip-path=\"url(#clip0_22624_675)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm-1 6.005v5H6v2h5v5h2v-5h5v-2h-5v-5h-2z\" fill=\"#7B61FF\"/></g><defs><clipPath id=\"clip0_22624_675\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};